"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetBillingListItem = class FieldsetBillingListItem extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    currentCurrency(...args) {
        return _.find(this.currencies, { code: this.item.currency });
    }
    createInvoiceLineCalculator(...args) {
        const [force] = args;
        if (force === true || this._invoiceLineCalculator == null) {
            const currency = this.currentCurrency();
            if (currency == null) {
                return;
            }
            this._invoiceLineCalculator = new this.$app.helpers.InvoiceLineCalculator(currency, this.taxCodes);
        }
        return this._invoiceLineCalculator;
    }
    syncExchangeRate(...args) {
        const v = this.exchange_rate;
        this.item.exchange_rate = v.value == null ? null : v;
        if (this._invoiceLineCalculator) {
            this._invoiceLineCalculator.recalculateLineItem(this.item, 'base_price');
        }
    }
    onContractChanged(...args) {
        const contract = this.item.contract;
        if (contract) {
            this.item.company = contract.company;
            this.item.partner = contract.client;
            this.item.rental = contract.rental;
        }
    }
    onContractServiceChanged(...args) {
        const contract_service = this.item.contract_service;
        if (contract_service) {
            this.item.contract = contract_service.contract;
            this.item.description = contract_service.name;
            if (contract_service.invoice_notes) {
                this.item.notes = contract_service.invoice_notes;
            }
            this.onContractChanged();
            this.getCurrentServicePrice(contract_service.id);
        }
    }
    getCurrentServicePrice(...args) {
        const [id] = args;
        this.$fn.fetch('read_contract_service', { parameters: { id } })
            .then(res => {
            if (!res.current_fee) {
                return;
            }
            const fee = res.current_fee;
            this.item.base_price = { amount: fee.amount, currency: fee.currency };
            if (this.item.currency != res.billing_currency) {
                this.item.currency = res.billing_currency;
                this.createInvoiceLineCalculator(true);
            }
            this.invoiceLineCalculator.applyContractServiceFee(this.item, res, res.current_fee);
        });
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    form;
    onForm(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("form");
    }
    isSaving;
    onIs_saving(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("isSaving");
    }
    currencies;
    async $$load_currencies() {
        return this.$app.repo.get('list_currency');
    }
    taxCodes;
    async $$load_taxCodes() {
        return this.$app.repo.get('list_tax_code');
    }
    invoiceLineCalculator;
    async $$load_invoiceLineCalculator() {
        return this.createInvoiceLineCalculator();
    }
    exchange_rate;
    async $$load_exchange_rate() {
        return this.item.exchange_rate || { value: null, date: null, source: null };
    }
    base_price;
    async $$load_base_price() {
        return _.extend({ amount: null, currency: null }, this.item.base_price);
    }
    exchangeRateSources;
    async $$load_exchangeRateSources() {
        return this.$app.repo.get('ui_metadata', { path: 'exchange_rate_source_options' });
    }
    ux;
    b_6610553441758910_parameters;
    dataMembers = ['currencies', 'taxCodes', 'invoiceLineCalculator', 'exchange_rate', 'base_price', 'exchangeRateSources', 'ux', 'b_6610553441758910_parameters'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                currencies: null,
                taxCodes: null,
                invoiceLineCalculator: null,
                exchange_rate: null,
                base_price: null,
                exchangeRateSources: null,
                ux: null,
                b_6610553441758910_parameters: {
                    role: "own",
                },
            },
        };
    }
    get isReadonly() {
        if (this.loaded) {
            return this.item.isReadonly || false;
        }
        return null;
    }
    get currency() {
        if (this.loaded) {
            return _.find(this.currencies, { code: this.item.currency });
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_script_6596_getActionArgs_value($event) {
        this.onContractServiceChanged();
    }
    async act_6466705138206980_script_6596_getActionArgs($event) {
        return {
            value: () => this.act_6466705138206980_script_6596_getActionArgs_value($event),
        };
    }
    async evh_6466705138206980_optionSelected(event, scope) {
        return await this.actions.evh_6466705138206980_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_3943151158818434_script_6598_getActionArgs_value($event) {
        this.onContractChanged();
    }
    async act_3943151158818434_script_6598_getActionArgs($event) {
        return {
            value: () => this.act_3943151158818434_script_6598_getActionArgs_value($event),
        };
    }
    async evh_3943151158818434_optionSelected(event, scope) {
        return await this.actions.evh_3943151158818434_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_5685441140616476_script_6600_getActionArgs_value($event) {
        this.invoiceLineCalculator.recalculateLineItem(this.item, 'base_price');
    }
    async act_5685441140616476_script_6600_getActionArgs($event) {
        return {
            value: () => this.act_5685441140616476_script_6600_getActionArgs_value($event),
        };
    }
    async evh_5685441140616476_changed(event, scope) {
        return await this.actions.evh_5685441140616476_changed.executeFromDOM(this, event, scope);
    }
    async act_1175399472650195_script_6602_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_1175399472650195_script_6602_getActionArgs($event) {
        return {
            value: () => this.act_1175399472650195_script_6602_getActionArgs_value($event),
        };
    }
    async evh_1175399472650195_blur(event, scope) {
        return await this.actions.evh_1175399472650195_blur.executeFromDOM(this, event, scope);
    }
    async act_2786108381738342_script_6604_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_2786108381738342_script_6604_getActionArgs($event) {
        return {
            value: () => this.act_2786108381738342_script_6604_getActionArgs_value($event),
        };
    }
    async evh_2786108381738342_blur(event, scope) {
        return await this.actions.evh_2786108381738342_blur.executeFromDOM(this, event, scope);
    }
    async act_7888454496860501_script_6606_getActionArgs_value($event) {
        this.syncExchangeRate();
    }
    async act_7888454496860501_script_6606_getActionArgs($event) {
        return {
            value: () => this.act_7888454496860501_script_6606_getActionArgs_value($event),
        };
    }
    async evh_7888454496860501_blur(event, scope) {
        return await this.actions.evh_7888454496860501_blur.executeFromDOM(this, event, scope);
    }
    async act_5418559842130999_script_6608_getActionArgs_value($event) {
        this.invoiceLineCalculator.recalculateLineItem(this.item, 'quantity');
    }
    async act_5418559842130999_script_6608_getActionArgs($event) {
        return {
            value: () => this.act_5418559842130999_script_6608_getActionArgs_value($event),
        };
    }
    async evh_5418559842130999_blur(event, scope) {
        return await this.actions.evh_5418559842130999_blur.executeFromDOM(this, event, scope);
    }
    async act_7916821937533317_script_6610_getActionArgs_value($event) {
        this.invoiceLineCalculator.recalculateLineItem(this.item, 'price');
    }
    async act_7916821937533317_script_6610_getActionArgs($event) {
        return {
            value: () => this.act_7916821937533317_script_6610_getActionArgs_value($event),
        };
    }
    async evh_7916821937533317_blur(event, scope) {
        return await this.actions.evh_7916821937533317_blur.executeFromDOM(this, event, scope);
    }
    async act_4441335657753065_setData_6612_getActionArgs($event) {
        return {
            path: "invoiceLineCalculator",
            value: this.createInvoiceLineCalculator(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_4441335657753065_input(event, scope) {
        return await this.actions.evh_4441335657753065_input.executeFromDOM(this, event, scope);
    }
    async act_6529453708504681_script_6614_getActionArgs_value($event) {
        this.invoiceLineCalculator.recalculateLineItem(this.item, 'discount');
    }
    async act_6529453708504681_script_6614_getActionArgs($event) {
        return {
            value: () => this.act_6529453708504681_script_6614_getActionArgs_value($event),
        };
    }
    async evh_6529453708504681_blur(event, scope) {
        return await this.actions.evh_6529453708504681_blur.executeFromDOM(this, event, scope);
    }
    async act_2837120413286864_script_6616_getActionArgs_value($event) {
        this.invoiceLineCalculator.recalculateLineItem(this.item, 'net_amount');
    }
    async act_2837120413286864_script_6616_getActionArgs($event) {
        return {
            value: () => this.act_2837120413286864_script_6616_getActionArgs_value($event),
        };
    }
    async evh_2837120413286864_blur(event, scope) {
        return await this.actions.evh_2837120413286864_blur.executeFromDOM(this, event, scope);
    }
    async act_1200777560175496_script_6618_getActionArgs_value($event) {
        this.invoiceLineCalculator.recalculateLineItem(this.item, 'tax_code');
    }
    async act_1200777560175496_script_6618_getActionArgs($event) {
        return {
            value: () => this.act_1200777560175496_script_6618_getActionArgs_value($event),
        };
    }
    async evh_1200777560175496_blur(event, scope) {
        return await this.actions.evh_1200777560175496_blur.executeFromDOM(this, event, scope);
    }
    async act_6300315092833989_script_6620_getActionArgs_value($event) {
        this.invoiceLineCalculator.recalculateLineItem(this.item, 'amount');
    }
    async act_6300315092833989_script_6620_getActionArgs($event) {
        return {
            value: () => this.act_6300315092833989_script_6620_getActionArgs_value($event),
        };
    }
    async evh_6300315092833989_blur(event, scope) {
        return await this.actions.evh_6300315092833989_blur.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_6594 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_6593 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_6594,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_6593],
        });
        const act_6466705138206980_script_6596 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6466705138206980_script_6596_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_optionSelected_6595 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_script_6596,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_6466705138206980_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_optionSelected_6595],
        });
        const act_3943151158818434_script_6598 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3943151158818434_script_6598_getActionArgs,
            events: [],
        });
        const evh_3943151158818434_optionSelected_6597 = new core_1.actions.EventHandlerImpl({
            action: act_3943151158818434_script_6598,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_3943151158818434_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3943151158818434_optionSelected_6597],
        });
        const act_5685441140616476_script_6600 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5685441140616476_script_6600_getActionArgs,
            events: [],
        });
        const evh_5685441140616476_changed_6599 = new core_1.actions.EventHandlerImpl({
            action: act_5685441140616476_script_6600,
            event: "changed",
            displayName: "script",
        });
        const evh_5685441140616476_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5685441140616476_changed_6599],
        });
        const act_1175399472650195_script_6602 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1175399472650195_script_6602_getActionArgs,
            events: [],
        });
        const evh_1175399472650195_blur_6601 = new core_1.actions.EventHandlerImpl({
            action: act_1175399472650195_script_6602,
            event: "blur",
            displayName: "script",
        });
        const evh_1175399472650195_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1175399472650195_blur_6601],
        });
        const act_2786108381738342_script_6604 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2786108381738342_script_6604_getActionArgs,
            events: [],
        });
        const evh_2786108381738342_blur_6603 = new core_1.actions.EventHandlerImpl({
            action: act_2786108381738342_script_6604,
            event: "blur",
            displayName: "script",
        });
        const evh_2786108381738342_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2786108381738342_blur_6603],
        });
        const act_7888454496860501_script_6606 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7888454496860501_script_6606_getActionArgs,
            events: [],
        });
        const evh_7888454496860501_blur_6605 = new core_1.actions.EventHandlerImpl({
            action: act_7888454496860501_script_6606,
            event: "blur",
            displayName: "script",
        });
        const evh_7888454496860501_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7888454496860501_blur_6605],
        });
        const act_5418559842130999_script_6608 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5418559842130999_script_6608_getActionArgs,
            events: [],
        });
        const evh_5418559842130999_blur_6607 = new core_1.actions.EventHandlerImpl({
            action: act_5418559842130999_script_6608,
            event: "blur",
            displayName: "script",
        });
        const evh_5418559842130999_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5418559842130999_blur_6607],
        });
        const act_7916821937533317_script_6610 = new core_1.actions.ScriptAction({
            actionArgs: this.act_7916821937533317_script_6610_getActionArgs,
            events: [],
        });
        const evh_7916821937533317_blur_6609 = new core_1.actions.EventHandlerImpl({
            action: act_7916821937533317_script_6610,
            event: "blur",
            displayName: "script",
        });
        const evh_7916821937533317_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7916821937533317_blur_6609],
        });
        const act_4441335657753065_setData_6612 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4441335657753065_setData_6612_getActionArgs,
            events: [],
        });
        const evh_4441335657753065_input_6611 = new core_1.actions.EventHandlerImpl({
            action: act_4441335657753065_setData_6612,
            event: "input",
            displayName: "setData",
        });
        const evh_4441335657753065_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4441335657753065_input_6611],
        });
        const act_6529453708504681_script_6614 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6529453708504681_script_6614_getActionArgs,
            events: [],
        });
        const evh_6529453708504681_blur_6613 = new core_1.actions.EventHandlerImpl({
            action: act_6529453708504681_script_6614,
            event: "blur",
            displayName: "script",
        });
        const evh_6529453708504681_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6529453708504681_blur_6613],
        });
        const act_2837120413286864_script_6616 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2837120413286864_script_6616_getActionArgs,
            events: [],
        });
        const evh_2837120413286864_blur_6615 = new core_1.actions.EventHandlerImpl({
            action: act_2837120413286864_script_6616,
            event: "blur",
            displayName: "script",
        });
        const evh_2837120413286864_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2837120413286864_blur_6615],
        });
        const act_1200777560175496_script_6618 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1200777560175496_script_6618_getActionArgs,
            events: [],
        });
        const evh_1200777560175496_blur_6617 = new core_1.actions.EventHandlerImpl({
            action: act_1200777560175496_script_6618,
            event: "blur",
            displayName: "script",
        });
        const evh_1200777560175496_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1200777560175496_blur_6617],
        });
        const act_6300315092833989_script_6620 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6300315092833989_script_6620_getActionArgs,
            events: [],
        });
        const evh_6300315092833989_blur_6619 = new core_1.actions.EventHandlerImpl({
            action: act_6300315092833989_script_6620,
            event: "blur",
            displayName: "script",
        });
        const evh_6300315092833989_blur = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6300315092833989_blur_6619],
        });
        return {
            act_7315092382398562_reloadComponentData_6594,
            evh_7315092382398562_reload_6593,
            evh_7315092382398562_reload,
            act_6466705138206980_script_6596,
            evh_6466705138206980_optionSelected_6595,
            evh_6466705138206980_optionSelected,
            act_3943151158818434_script_6598,
            evh_3943151158818434_optionSelected_6597,
            evh_3943151158818434_optionSelected,
            act_5685441140616476_script_6600,
            evh_5685441140616476_changed_6599,
            evh_5685441140616476_changed,
            act_1175399472650195_script_6602,
            evh_1175399472650195_blur_6601,
            evh_1175399472650195_blur,
            act_2786108381738342_script_6604,
            evh_2786108381738342_blur_6603,
            evh_2786108381738342_blur,
            act_7888454496860501_script_6606,
            evh_7888454496860501_blur_6605,
            evh_7888454496860501_blur,
            act_5418559842130999_script_6608,
            evh_5418559842130999_blur_6607,
            evh_5418559842130999_blur,
            act_7916821937533317_script_6610,
            evh_7916821937533317_blur_6609,
            evh_7916821937533317_blur,
            act_4441335657753065_setData_6612,
            evh_4441335657753065_input_6611,
            evh_4441335657753065_input,
            act_6529453708504681_script_6614,
            evh_6529453708504681_blur_6613,
            evh_6529453708504681_blur,
            act_2837120413286864_script_6616,
            evh_2837120413286864_blur_6615,
            evh_2837120413286864_blur,
            act_1200777560175496_script_6618,
            evh_1200777560175496_blur_6617,
            evh_1200777560175496_blur,
            act_6300315092833989_script_6620,
            evh_6300315092833989_blur_6619,
            evh_6300315092833989_blur,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetBillingListItem.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetBillingListItem.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetBillingListItem.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetBillingListItem.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetBillingListItem.prototype, "form", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('form'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetBillingListItem.prototype, "onForm", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], FieldsetBillingListItem.prototype, "isSaving", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isSaving'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetBillingListItem.prototype, "onIs_saving", null);
FieldsetBillingListItem = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetBillingListItem);
exports.default = FieldsetBillingListItem;
vue_property_decorator_1.Vue.component("FieldsetBillingListItem", FieldsetBillingListItem);
